import React, { useState } from 'react';
import supabase from '../supabase';

const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setStatus('');
    try {
      const { error } = await supabase
        .from('contact_submissions')
        .insert({
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
          status: 'Unread'
        });
      if (error) {
        setStatus('Failed to send. Please try again.');
      } else {
        setStatus('Thank you! Your message has been sent.');
        setForm({ name: '', email: '', subject: '', message: '' });
      }
    } catch (err) {
      setStatus('Error sending message.');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: '4rem auto', padding: '2rem', background: '#18181b', borderRadius: 12, color: 'white', boxShadow: '0 4px 24px rgba(0,0,0,0.2)' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem', color: '#ff0080' }}>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontWeight: '600' }}>Name</label>
          <input name="name" value={form.name} onChange={handleChange} required style={{ width: '100%', padding: '0.75rem', borderRadius: 6, border: '1px solid #333', marginTop: 4, background: '#222', color: 'white' }} />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontWeight: '600' }}>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} required style={{ width: '100%', padding: '0.75rem', borderRadius: 6, border: '1px solid #333', marginTop: 4, background: '#222', color: 'white' }} />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontWeight: '600' }}>Subject</label>
          <input name="subject" value={form.subject} onChange={handleChange} required style={{ width: '100%', padding: '0.75rem', borderRadius: 6, border: '1px solid #333', marginTop: 4, background: '#222', color: 'white' }} />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontWeight: '600' }}>Message</label>
          <textarea name="message" value={form.message} onChange={handleChange} required rows={5} style={{ width: '100%', padding: '0.75rem', borderRadius: 6, border: '1px solid #333', marginTop: 4, background: '#222', color: 'white', resize: 'vertical' }} />
        </div>
        <button type="submit" disabled={loading} style={{ background: 'linear-gradient(45deg, #ff0080, #7928ca)', color: 'white', padding: '0.75rem 2rem', border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer', width: '100%' }}>
          {loading ? 'Sending...' : 'Send Message'}
        </button>
      </form>
      {status && <div style={{ marginTop: '1.5rem', color: status.includes('Thank you') ? '#00ff80' : '#ff0080', textAlign: 'center', fontWeight: '600' }}>{status}</div>}
    </div>
  );
};

export default ContactUs;
